import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Telegram = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 20"
    {...props}
  >
    <path
      id="telegram_layer"
      fill="hsl(from hsl(200 78% 52%) h s 63%)"
      d="M1.6,8.9c6.2-2.7,10.3-4.5,12.3-5.3c5.9-2.5,7.1-2.9,7.9-2.9c0.2,0,0.6,0,0.8,0.2
	c0.2,0.2,0.3,0.4,0.3,0.6s0.1,0.5,0,0.8c-0.3,3.4-1.7,11.5-2.4,15.2c-0.3,1.6-0.9,2.1-1.4,2.2c-1.2,0.1-2.2-0.8-3.4-1.6
	c-1.9-1.2-2.9-2-4.7-3.2c-2.1-1.4-0.7-2.1,0.5-3.4c0.3-0.3,5.7-5.3,5.8-5.7c0-0.1,0-0.3-0.1-0.4s-0.3-0.1-0.4,0
	c-0.2,0-3.2,2-8.9,5.9c-0.9,0.7-1.6,1-2.3,1c-0.8,0-2.2-0.4-3.3-0.8C1,11.1-0.1,10.8,0,10.1C0.1,9.7,0.6,9.3,1.6,8.9z"
    />
  </svg>
);
